// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__doyj5","input--sm":"Checkbox_input--sm__5XiZr","input--lg":"Checkbox_input--lg__KXXT8"};